import React from 'react';
import UnifiedOfficeSalesDashboard from './UnifiedOfficeSalesDashboard';

const OfficeSalesPersonDashboard = ({ activeView }) => {
  return <UnifiedOfficeSalesDashboard activeView={activeView} />;
};

export default OfficeSalesPersonDashboard;
